import "./Invoicing.scss";

type InvoicingType = {
  children: React.ReactNode;
};

export const Invoicing = (props: InvoicingType) => {
  return <section className="invoicing-container">{props.children}</section>;
};
